// Centralized contact info for TraderTekno admin support.
// Update the constant below when the admin channel changes — every
// 'Kontak Admin' entry point in the UI reads from here.

export const ADMIN_WHATSAPP_NUMBER = '6281188001996';

/**
 * Build a wa.me deep link that opens WhatsApp with a prefilled message
 * targeted at the admin number. Falls back to a generic greeting when
 * no message is provided.
 */
export function buildAdminWhatsAppLink(message?: string): string {
  const defaultMsg = 'Halo admin TraderTekno, saya butuh bantuan.';
  const text = encodeURIComponent(message ?? defaultMsg);
  return `https://wa.me/${ADMIN_WHATSAPP_NUMBER}?text=${text}`;
}
